<template>
  <div class="modal-cadastro-empresa">
    <v-dialog :value="show" @input="fechar" max-width="800">
      <v-card>
        <v-card-title>{{ titleComputed }}</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <input type="hidden" v-model="item.id" />
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.cnpj"
                  label="Nr. do CNPJ"
                  :rules="requiredRules"
                  v-mask="'##.###.###/####-##'"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.nome"
                  label="Nome da empresa"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.fantasia"
                  label="Nome fantasia"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.endereco"
                  label="Emdereço"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.bairro"
                  label="Bairro"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.municipio"
                  label="Município"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.uf"
                  label="Estado"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-text-field
                  outlined
                  v-model="item.cep"
                  label="CEP"
                  v-mask="'#####-###'"
                  :rules="requiredRules"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-checkbox 
                  v-model="item.status"
                  label="Status">
                </v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" outlined @click="fechar">cancelar</v-btn>
          <v-btn color="primary" @click="salvar(item)">salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: "ModalCadastroEmpresa",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      valid: true,
      requiredRules: [v => !!v || "Este Campo é Obrigatório"]
    };
  },
  methods: {
    fechar() {
      this.$emit("fechar");
      this.$refs.form.resetValidation();
    },
    salvar(empresa) {
      if (!this.$refs.form.validate()) return;

      empresa.cnpj   = empresa.cnpj.replace(/[^\d]/g, '');
      empresa.cep    = empresa.cep.replace(/[^\d]/g, '');
      empresa.status = empresa.status ? 'ativo' : 'inativo';
      this.$emit("submit", empresa);
    }
  },
  computed: {
    titleComputed() {
      return this.item.id ? "Editar de Empresa" : "Cadastro de Empresa";
    }
  },
  watch: {
    item: function(newItem) {
      this.item = { ...newItem };
    }
  }
};
</script>
